<template>
  <div class="card" :class="{'card-plain': isPlain}">
    <div v-if="data != null"  class="card-header" data-background-color="magenta-dark">
      <slot name="header">
        <h4 class="title">{{title}}</h4>
        <p class="category">{{subTitle}}</p>
      </slot>
    </div>
    <div v-if="data != null && data.length > 0" class="card-content table-responsive">
      <table class="table table-striped table-hover" :class="tableClass">
        <thead>
        <th></th>
        <th v-for="colTitle in columnsTitles">{{colTitle}}</th>
        </thead>
        <tbody>
        <tr v-for="item in data">
          <td>
            <input class="form-check-input" name="radio" type="radio" v-model="selected" :value="item" @change="rowSelected">
          </td>
          <td v-for="attributeName in columnsValues" v-if="hasValue(item, attributeName)">{{itemValue(item, attributeName)}}</td>
        </tr>          
        </tbody>
      </table>
    </div>
    <div v-if="data != null && data.length == 0">
      <br><h4 id="no_data">No hay resultados para mostrar</h4>
    </div>

  </div>
</template>
<script>

  export default {
    data () {
      return {
        selected: null
      }
    },
    props: {
      columnsTitles: Array,
      columnsValues: Array,
      data: Array,
      type: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''

      }
    },
    computed: {
      tableClass () {
        return `table-${this.type}`
      },
      isPlain () {
        return this.type === 'plain'
      }
    },
    methods: {
      rowSelected () {
        this.$emit('rowSelectedChange', this.selected)
      },
      itemValue (item, column) {
        let path = column.split('.')
        // console.log(JSON.stringify((item['info'])['make']) )
        // console.log(path)
        let itemValue = item[path[0].toLowerCase()]
        let i = 1
        while (path.length > i) {
            itemValue  = itemValue[path[i].toLowerCase()]
            i ++
        }
        return itemValue  
      },
      hasValue (item, column) {
        return this.itemValue (item, column) !== 'undefined'
      }
    }
  }

</script>
<style>
#no_data {
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// TableWithCheckbox.vue?74c6924e